export enum CrossFitTableActionType {
    SetColumnGrouping = "SET_COL_GROUPING",
    SetHiddenColumnGrouping = "SET_HIDDEN_COL_GROUPING",
    SetStateHiddenColumnGrouping = "SET_STATE_HIDDEN_COL_GROUPING",
    ColumnGroupingBatch = "ColumnGroupingBatch",
    SetLoading = "SET_LOADING",
}

export type CrossFitTableColumnGroupingAction =
    | {
          type: CrossFitTableActionType.SetColumnGrouping;
          payload: {
              stickyTablePath: string;
              groupKey: undefined | string;
              isShowColumns: boolean;
              doNotThrottle: boolean;
          };
      }
    | {
          type: CrossFitTableActionType.SetHiddenColumnGrouping;
          payload: {
              stickyTablePath: string;
              groupKey: undefined | string;
              isShowColumns: boolean;
              doNotThrottle: boolean;
          };
      }
    | {
          type: CrossFitTableActionType.SetStateHiddenColumnGrouping;
          payload: {
              stickyTablePath: string;
              groupKey: undefined | string;
              isShowColumns: boolean;
          };
      }
    | {
          type: CrossFitTableActionType.SetLoading;
          payload: {
              stickyTablePath: string;
              loading: boolean;
          };
      };

export type CrossFitTableAction =
    | CrossFitTableColumnGroupingAction
    | {
          type: CrossFitTableActionType.ColumnGroupingBatch;
          payload: {
              events: CrossFitTableColumnGroupingAction[];
          };
      }
    | {
          type: CrossFitTableActionType.SetLoading;
          payload: {
              stickyTablePath: string;
              loading: boolean;
          };
      };
